export default __webpack_public_path__ + "static/media/MeineSilos.feef835c.jpg";